import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import ModalForgotPasswordRestaurant from '../../components/ModalForgotPasswordRestaurant';
import { LoginRestaurantRequest, ForgotPasswordRestaurant } from '../../Api/AuthRestaurant';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { AjouteRestaurant } from '../../Redux/actions/actionRestaurant';
import '../../Css/loginRestaurant.css';
import Logo from '../../Image/logo.png';

const LoginRestaurant = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingForgot, setLoadingForgot] = useState(false);
  const [errorEmail, setErrorEmail] = useState('');

  let location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleShowPassword = () => setShowPass(!showPass);


  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrorEmail('');
  }

  const handlePassword = (e) => {
    setPassword(e.target.value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = { email: email, password: password };
    LoginRestaurantRequest(data).then(function (response) {
      console.log(response);
      localStorage.setItem('restaurant', JSON.stringify(response.data.donner));
      localStorage.setItem('tokenRestaurant', response.data.token);
      localStorage.setItem('idResto', JSON.stringify(response.data.donner.id));
      dispatch(AjouteRestaurant(response.data.donner));
      if (response.data.title === "success") {
        navigate('/adminRestaurant/presentation');
      }
    }).catch(function (error) {
      console.log(error);
      if (error) {
        toast.error(error.response?.data?.message);
      }
    }).finally(function () {
      setLoading(false);
    });
  }

  const handleForgot = () => {
    // Vérifier si l'email est vide
    if (!email || email.trim() === '') {
      setErrorEmail("L'email est obligatoire pour récupérer votre mot de passe");
      return; // On quitte la fonction
    }

    setErrorEmail(null); // Réinitialise l'erreur si l'email est présent
    setLoadingForgot(true);

    const data = { email: email };

    ForgotPasswordRestaurant(data)
      .then(function (response) {
        if (response.data.title === "success") {
          toast.success(response?.data?.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        if (error) {
          setErrorEmail(error.response?.data?.message);
        }
      })
      .finally(function () {
        setEmail('');
        setLoadingForgot(false);
      });
  };


  return (
    <div>
      <Helmet>
        <title>Restaurant ~ Login</title>
        <meta name='description' content='Login restaurant.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='login_restaurant'>
        {loading && <Loader />}
        <div className='col-12 col-sm-10 col-md-10 col-lg-10 col-xl-6 mx-auto'>
          <div className='content_login_restaurant'>
            <div className='bloc_description'>
              <div className='bloc_1'>
                <h1 className='text-center'>Restaurateur login</h1>
                <h2 className='mt-2'>Plateforme de recherche et de réservation de restaurants, xxx vous permet une meilleure visibilité auprès de vos clients.</h2>
              </div>
              <div className='bloc_2'>
                <h2 className='visible'> Visibilité et Inscription gratuite.</h2>
                <h2 className='suivre'> Rejoignez-nous !</h2>
              </div>
              <div className='bloc_3'>
                <h2 className='text'>Contact</h2>
                <h2 className='text'>je suis intéressé !</h2>
                <h2 className='text'>Aide</h2>
              </div>
            </div>
            <div className='bloc_form'>
              <div className='d-flex justify-content-center'>
                <div className='login_logo'>
                  <img src={Logo} alt="logo e-kaly" />
                </div>
              </div>
              <form onSubmit={handleSubmit} className='mt-4'>
                <div className="mb-3">
                  <div className='d-flex justify-content-start'>
                    <label className="form-label">Adresse e-mail</label>
                  </div>
                  <input type="email" className="form-control" id="email" value={email} onChange={handleEmail} placeholder="Adresse e-mail ..." required />
                  {errorEmail !== "" ? <span style={{ fontSize: '13px', fontWeight: 500, color:'red' }}>{errorEmail}</span> : ""}
                </div>
                <div className="mb-3">
                  <div className='d-flex justify-content-start'>
                    <label className="form-label">Mot de passe</label>
                  </div>
                  <input type={showPass ? "text" : "password"} value={password} onChange={handlePassword} className="form-control" required id="password" placeholder="Mot de passe ..." />
                </div>
                <div className='d-flex justify-content-end'>
                  <i className={showPass ? 'fa fa-eye-slash' : 'fa fa-eye'} onClick={handleShowPassword} ></i>
                </div>
                <div className='d-flex justify-content-end'>
                  {loadingForgot ? <span>Chargement...</span> : <span onClick={handleForgot}>Mot de passe oublié</span>}

                </div>
                <button type='submit' className='btn w-100'>Connexion</button>
              </form>
              <p className="version">Version 1</p>
            </div>
          </div>
        </div>
      </div>
      <ModalForgotPasswordRestaurant
        show={modalShow}
        onHide={() => setModalShow(false)} />
    </div>
  )
}

export default LoginRestaurant